<template>
    <v-row>
        <v-col cols="12">
            <v-radio-group v-model="form.service_type" inline>
                <v-row class="align-center mt-4" no-gutters>
                    <v-col cols="6" md="3" class="multi-city-toggle mb-0 mr-3" :class="$display.smAndDown ? 'mr-2' : 'mr-3'">
                        <label class="toggle-switch">
                            <v-radio label="from airport" value="from_airport" color="#005886" />
                        </label>
                    </v-col>
                    <v-col cols="5" md="3" class="multi-city-toggle mb-0 mr-3" :class="$display.smAndDown ? 'mr-2' : 'mr-3'">
                        <label class="toggle-switch">
                            <v-radio label="to airport" value="to_airport" color="#005886" />
                        </label>
                    </v-col>
                </v-row>
            </v-radio-group>
        </v-col>
    </v-row>

    <v-row>
        <!-- From Airport -->
        <v-col cols="12" sm="6" md="4">
            <v-autocomplete v-model="form.sourceAddress" :items="pickupSuggestions" :loading="pickupLoading"
                :list-props="{ class: 'custom-list', maxWidth: '385px' }"
                :label="form.service_type === 'from_airport' ? 'Select Airport' : 'Pickup Address'"
                :placeholder="form.service_type === 'from_airport' ? 'Search Airport' : 'Enter Address'"
                variant="outlined" hide-no-data no-filter item-title="description" item-value="place_id"
                @update:search="fetchPickupSuggestions" @update:modelValue="onPickupSelected" return-object>
                <template #prepend-inner>
                    <v-icon style="color: #005886">mdi-map-marker</v-icon>
                </template>
            </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-autocomplete v-model="form.destinationAddress" :items="dropSuggestions" :loading="pickupLoading"
                :list-props="{ class: 'custom-list', maxWidth: '385px' }"
                :label="form.service_type === 'from_airport' ? 'Drop-off Address' : 'Select Airport'"
                :placeholder="form.service_type === 'from_airport' ? 'Enter Address' : 'Search Airport'"
                variant="outlined" hide-no-data no-filter item-title="description" item-value="place_id"
                @update:search="fetchDropSuggestions" @update:modelValue="onDropSelected" clearable return-object>
                <template #prepend-inner>
                    <v-icon style="color: #005886">mdi-map-marker</v-icon>
                </template>
            </v-autocomplete>
        </v-col>
        <!-- Date -->
        <v-col cols="12" sm="6" md="2">
            <v-menu v-model="menuDateAirport" :close-on-content-click="false" transition="scale-transition" offset-y>
                <template #activator="{ props }">
                    <v-text-field v-model="formattedAirportDate" label="Pickup Date" readonly v-bind="props"
                        variant="outlined" color="#005886" required>
                        <template #prepend-inner>
                            <v-icon style="color: #005886">mdi-calendar</v-icon>
                        </template>
                    </v-text-field>
                </template>
                <v-date-picker v-model="form.startDate" :min="minDate" color="#005886" show-adjacent-months
                    @update:model-value="onDateSelected" />
            </v-menu>
        </v-col>

        <!-- Time -->
        <v-col cols="12" sm="6" md="2">
            <v-text-field v-model="form.startTime" label="Pickup Time" type="time" variant="outlined" color="#005886"
                required>
                <template #prepend-inner>
                    <v-icon style="color: #005886">mdi-clock</v-icon>
                </template>
            </v-text-field>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "AirportTripForm",
    props: {
        modelValue: { type: Object, required: true },
        pickupSuggestions: Array,
        dropSuggestions: Array,
        pickupLoading: Boolean,
    },
    emits: ["update:modelValue", "fetchPickupSuggestions", "fetchDropSuggestions", "pickupSelected", "dropSelected"],
    data() {
        return {
            menuDateAirport: false,
            formattedAirportDate: '',
        };
    },
    computed: {
        form: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
        minDate() {
            return new Date().toISOString().split('T')[0];
        },
    },
    watch: {
        'form.startDate': {
            handler(newVal) {
                if (newVal) {
                    // Format to YYYY-MM-DD for display
                    const d = new Date(newVal);
                    const yyyy = d.getFullYear();
                    const mm = String(d.getMonth() + 1).padStart(2, '0');
                    const dd = String(d.getDate()).padStart(2, '0');
                    this.formattedAirportDate = `${yyyy}-${mm}-${dd}`;
                } else {
                    this.formattedAirportDate = '';
                }
            },
            immediate: true,
        },
    },
    methods: {
        onDateSelected(val) {
            if (val) {
                // Ensure form.startDate is a string in YYYY-MM-DD format
                const d = new Date(val);
                const yyyy = d.getFullYear();
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                this.form.startDate = `${yyyy}-${mm}-${dd}`;
                this.formattedAirportDate = this.form.startDate;
            }
            this.menuDateAirport = false; // Close the menu after selection
        },
        fetchPickupSuggestions(query) {
            if (this.form.service_type === 'from_airport') {
                this.$emit("fetchPickupSuggestions", query + ' airport terminal');
            }else{
                this.$emit("fetchPickupSuggestions", query);
            }
        },
        fetchDropSuggestions(query) {
            if (this.form.service_type === 'to_airport') {
                this.$emit("fetchDropSuggestions", query + ' airport terminal');
            }else{
                this.$emit("fetchDropSuggestions", query);
            }
        },
        onPickupSelected(val) {
            this.$emit("pickupSelected", val);
        },
        onDropSelected(val) {
            this.$emit("dropSelected", val);
        },
    },
};
</script>